import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ViewerHistoryAPIService {
  constructor(private http: HttpClient) {}

  getLastReadPage(bid: string): Observable<string | null> {
    return this.http
      .get<{
        result: 'ok' | 'error';
        items?: {
          bukId: string;
          createdDate: string;
          title: string;
          type: string;
          url: string;
        }[];
      }>(`/history`, {
        params: { bukId: bid },
        withCredentials: true,
      })
      .pipe(
        map((response) => {
          if (response.items?.[0]) {
            return response.items[0].url.split('/')[2]
              ? response.items[0].url
              : `${response.items[0].url}/cover`;
          } else {
            return null;
          }
        })
      );
  }
}
